type TCur = {
  jumpUrlParams: string,
  jumpType: string,
}

export const getJumpUrl = (cur:TCur) => {
  const jumpUrlParams = JSON.parse(cur.jumpUrlParams)
  let url = ''
  switch (cur.jumpType) {
    case 'mn_blog':
      url = `/meinian/detail/image?imageGroupEntityId=${jumpUrlParams.imageGroupEntityId}&inspirationId=${jumpUrlParams.inspirationId}&collectId=${jumpUrlParams.collectId}`
      break
    case 'mn_blog_mission':
      url = `/meinian/detail/image?imageGroupEntityId=${jumpUrlParams.imageGroupEntityId}&inspirationId=${jumpUrlParams.inspirationId}&collectId=${jumpUrlParams.collectId}&postilId=${jumpUrlParams.postilId}`
      break
    case 'mn_blog_comment':
      url = `/meinian/detail/image?imageGroupEntityId=${jumpUrlParams.imageGroupEntityId}&inspirationId=${jumpUrlParams.inspirationId}&collectId=${jumpUrlParams.collectId}&commentId=${jumpUrlParams.commentId}`
      break
    case 'mn_blog_annotation':
      url = `/meinian/detail/image?imageGroupEntityId=${jumpUrlParams.imageGroupEntityId}&inspirationId=${jumpUrlParams.inspirationId}&collectId=${jumpUrlParams.collectId}&postilId=${jumpUrlParams.postilId}`
      break
    case 'mn_inspiration':
      url = `/meinian/home/coll/detail/${jumpUrlParams.inspirationId}?inspirationId=${jumpUrlParams.inspirationId}`
      break
    case 'mn_sample_comment_reply':
      url = `/meinian/detail/sample/image?sampleCode=${jumpUrlParams.sampleCode}&commentId=${jumpUrlParams.commentId}`
      break
    case 'mn_sample_annotation':
      url = `/meinian/detail/sample/image?sampleCode=${jumpUrlParams.sampleCode}&postilId=${jumpUrlParams.postilId}`
      break
    case 'mn_sample':
      url = `/meinian/detail/sample/image?sampleCode=${jumpUrlParams.sampleCode}`
      break
    default:
  }
  return url
}
